import { Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import CsvDownloader from 'react-csv-downloader';

import { DownloadIcon } from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface ICSVColumn {
  id: string;
  displayName: string;
}

interface IProps {
  columns: ICSVColumn[];
  datas: () => Promise<Record<string, any>[]>;
  filename: string;
  isDisabled: boolean;
  title: string;
}

// IMPORTANT: This is custom to the dashboard. Do not copy and paste.
export const CSVDownloadButton = ({ columns, datas, filename, isDisabled, title }: IProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const color = isHovered ? publicaColors.veryDarkGray : publicaColors.gray;

  return (
    <CsvDownloader
      columns={columns}
      datas={datas}
      filename={filename}
      extension='.csv'
      separator=';'
      disabled={isDisabled}
      title={title}
      newLineAtEnd
      meta={true}
    >
      <Tooltip title='Download chart data as CSV'>
        <div
          onMouseEnter={() => !isDisabled && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Cols
            gap={spacing.small}
            style={{
              alignItems: 'center',
              height: '30px',
              padding: '0 8px',
              borderRadius: '6px',
              border: `1px solid ${publicaColors.lightGray}`,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              color,
              opacity: isDisabled ? '0.4' : '1',
            }}
          >
            <Col displayFlex>
              <DownloadIcon color={color} style={{ height: '12px' }} />
            </Col>
          </Cols>
        </div>
      </Tooltip>
    </CsvDownloader>
  );
};
